const ISSUE_LEVELS = new Set(['error', 'fatal']);
const LOG_SEVERITY_FOR_CAPTURE = {
    warning: 'warn',
    log: 'info',
    info: 'info',
    debug: 'debug',
};
export function resolveCaptureLevel(level, hasException) {
    return level ?? (hasException ? 'error' : 'info');
}
export function posthogLaneForCapture(input) {
    if (input.hasException)
        return input.level === 'warning' ? 'log' : 'issue';
    return ISSUE_LEVELS.has(input.level) ? 'issue' : 'log';
}
export function posthogLogSeverityForLevel(level) {
    return LOG_SEVERITY_FOR_CAPTURE[level] ?? 'info';
}
export const POSTHOG_ROUTE_KEYS = new Set([
    'source',
    'capture_level',
    'transaction',
    'userId',
    'mechanism',
    '$exception_level',
    '$exception_fingerprint',
]);
export const CAPTURE_BRIDGE_TAGS = new Set(['via']);
export function forwardableCaptureTags(tags) {
    const out = {};
    for (const [key, value] of Object.entries(tags ?? {})) {
        if (CAPTURE_BRIDGE_TAGS.has(key))
            continue;
        out[POSTHOG_ROUTE_KEYS.has(key) ? `tag_${key}` : key] = value;
    }
    return out;
}
export function fingerprintFromParts(parts) {
    if (!parts || parts.length === 0)
        return undefined;
    return parts.map(part => String(part)).join(' · ');
}
//# sourceMappingURL=error-tracking-lane.js.map